import axios from 'axios';
import API_CONFIG from '../config/api';

const API_BASE = API_CONFIG.API_BASE;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

// --- Datasource Files ---

export const uploadDatasourceFile = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_BASE}/datasource-files/upload`, formData, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
  return response.data;
};

export const listDatasourceFiles = async () => {
  const response = await axios.get(`${API_BASE}/datasource-files`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getDatasourceFileColumns = async (fileId) => {
  const response = await axios.get(`${API_BASE}/datasource-files/${fileId}/columns`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteDatasourceFile = async (fileId) => {
  const response = await axios.delete(`${API_BASE}/datasource-files/${fileId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// --- Knowledge Bases ---

export const listKnowledgeBases = async () => {
  const response = await axios.get(`${API_BASE}/knowledge-bases`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const getKnowledgeBase = async (kbId) => {
  const response = await axios.get(`${API_BASE}/knowledge-bases/${kbId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const createKnowledgeBase = async (data) => {
  const response = await axios.post(`${API_BASE}/knowledge-bases`, data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const updateKnowledgeBase = async (kbId, data) => {
  const response = await axios.put(`${API_BASE}/knowledge-bases/${kbId}`, data, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const deleteKnowledgeBase = async (kbId) => {
  const response = await axios.delete(`${API_BASE}/knowledge-bases/${kbId}`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

// --- KB Files ---

export const addFileToKB = async (kbId, fileId) => {
  const response = await axios.post(
    `${API_BASE}/knowledge-bases/${kbId}/files`,
    { file_id: fileId },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const removeFileFromKB = async (kbId, fileId) => {
  const response = await axios.delete(
    `${API_BASE}/knowledge-bases/${kbId}/files/${fileId}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const detectChunkConfig = async (kbId) => {
  const response = await axios.get(
    `${API_BASE}/knowledge-bases/${kbId}/detect-chunks`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const processKnowledgeBase = async (kbId) => {
  const response = await axios.post(
    `${API_BASE}/knowledge-bases/${kbId}/process`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const previewChunks = async (kbId, fileId, limit = 10) => {
  const response = await axios.get(
    `${API_BASE}/knowledge-bases/${kbId}/chunks/${fileId}?limit=${limit}`,
    { headers: getAuthHeaders() }
  );
  return response.data;
};
